import { useCallback } from 'react'
import { useT } from '@transifex/react'
import { trackError } from '@vend/utilities'
import { ToastNotifications } from '@lightspeed/design-system-react'
import { ERROR_TYPES } from '../../util/types'
import { Sale } from '../../models/sale'
import { useSaleManager } from '../../ng-compat/hooks'

export const useSaleLoadErrors = () => {
  const t = useT()
  const saleManager = useSaleManager()

  const handleLoadError = useCallback(
    (saleToLoad: Sale | null, error: any) => {
      let errorType = error && error.type
      let message

      if (!errorType && error.status === 404) {
        errorType = ERROR_TYPES.LOAD_SALE_ABORTED_NOT_FOUND
      }

      switch (errorType) {
        case ERROR_TYPES.LOAD_SALE_ABORTED_NOT_FOUND:
          message = t('This sale can’t be found - please contact support.')
          break

        case ERROR_TYPES.LOAD_QUOTE_ABORTED_NOT_FOUND:
          message = t('Failed to retrieve quote.')
          break

        case ERROR_TYPES.LOAD_QUOTE_ABORTED_ARCHIVED:
          message = t('Cannot convert an archived quote to a sale')
          break

        case ERROR_TYPES.LOAD_QUOTE_ABORTED_NO_CUSTOMER:
          message = t('Cannot convert a quote to a sale without a customer')
          break

        case ERROR_TYPES.LOAD_QUOTE_ABORTED_NO_PRODUCTS:
          message = t('Cannot convert a quote without items to a sale')
          break

        case ERROR_TYPES.LOAD_SALE_ABORTED_VOIDED:
          message = 'This sale can’t be opened as it has been discarded.'
          message = t('This sale cant be opened as it has been discarded.')
          break

        case ERROR_TYPES.LOAD_SALE_ABORTED_COMPLETED:
          message = t('This sale has already been completed.')
          break

        case ERROR_TYPES.LOAD_SERVICE_ABORTED_INCOMPLETE:
          message = t(
            'Incomplete service. Continue the sale from sales history to proceed.'
          )
          break

        case ERROR_TYPES.LOAD_SERVICE_ABORTED_AGENDA_NOT_FOUND:
          message = t('Failed to retrieve service agenda')
          break

        case ERROR_TYPES.LOAD_SERVICE_ABORTED_SERVICE_ITEM_NOT_FOUND:
          message = t('Failed to retrieve service item')
          break
        default:
          trackError('[SaleCtrl] Unknown error loading sale', {
            data: { saleToLoad, error },
          })
          message = t('This sale failed to load, please try again.')
          break
      }
      ToastNotifications.negative(message)

      // Ensure we at least attempt to initialise the saleManager so we don't end up with a null/undefined sale
      return saleManager.init()
    },
    [saleManager, t]
  )

  return { handleLoadError }
}
